export enum LoginAction {
  SET_WXCODE = 'SET_WXCODE',               // 改变环境
  SET_PROPERTY = 'SET_PROPERTY'          // 修改属性
}